// extracted by mini-css-extract-plugin
module.exports = {"input":"_3aXk9","wrapper":"_3g6ey","radio":"_2bEBI","label":"_1HJOH"};